// checkLivestreamChatPreflight.js
'use strict';

import getOperationData from '../selector/getOperationData.js';
import fetchLivestreamChatPreflight from '../action/fetchLivestreamChatPreflight.js';
import addModal from '../action/addModal.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';

/**
 * Check livestream chat preflight
 * @kind action
 * @param {string} {streamId} - stream id.
 * @return {Promise} Action promise.
 */
const checkLivestreamChatPreflight =
  ({ streamId }) =>
  async (dispatch, getState) => {
    const selectPath = ['liveStream', streamId, 'chat', 'preflight'];
    const timestampOffsetSeconds = getTimestampOffset(
      getState(),
      Accuracy.SECOND
    );
    const now = getCurrentUnixTimestamp({
      offsetSeconds: timestampOffsetSeconds,
    });

    await dispatch(fetchLivestreamChatPreflight({ streamId }));

    const exp = getOperationData(getState(), selectPath, 'exp') || 0;
    if (exp <= now) {
      return dispatch(
        addModal({
          id: 'LiveStreamLimitedChatModal',
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
    }
  };

export default checkLivestreamChatPreflight;
